export const URL_ROUTES = {
  LANDING_SCREEN: "/",
  VOLUNTEER: "/volunteer",
  VOLUNTEER_RESULT: "/volunteer/submission",
  PRIVACY: "/privacy",
  TERMS: "/terms",

};

export const API_ROUTES = {
  GET_ANNOUNCEMENTS: "webFeatures/eventDetails",
  GET_DOWNLOAD_COUNT: 'webFeatures/userCount'
};

